export default "__VITE_ASSET__ibnvLRpi__"